defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Loader',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Mithril/Scripts/Helpers/Render'
  ],
  function (m, Render) {

    // Template:
    var Loader = function (controller) {

      // Variables:
      var render = Render();

      // Functions:
      var generateCubeFaces = function () {
        var cubeFaces = [];
        var cubeFace = m('div', { class: 'cube-face' }, [
          m('div', { class: 'square' }),
          m('div', { class: 'diamond' }),
          m('div', { class: 'circle' }),
          m('div', { class: 'triangle' })
        ]);
        var cubeInnerFace = m('div', { class: 'cube-inner-face' });
        var emoji = m('div', { class: 'emoji-face' }, [
          m('div', { class: 'eyes' }, [
            m('div', { class: 'eyebrows' })
          ]),
          m('div', { class: 'mouth' })
        ]);
        var numberOfFaces = 6;

        for (var i = 0; i < numberOfFaces; i++) {
          if (i === 0) {
            var cubeFaceWithEmoji = JSON.parse(JSON.stringify(cubeFace));

            cubeFaceWithEmoji.children.push(emoji);
            cubeFaces.push(cubeFaceWithEmoji);
          } else {
            cubeFaces.push(cubeFace);
          }
        }

        for (var j = 0; j < numberOfFaces; j++) {
          cubeFaces.push(cubeInnerFace);
        }

        return cubeFaces;
      };

      // Render:
      render.ready.then(function (nodes) {
        var cube = nodes['cube'];
        var cubeWrapper = nodes['cubeWrapper'];
        var $cube = cube.$element;
        var $cubeWrapper = cubeWrapper.$element;

        if (controller.error?.()) {
          var cycleEnd = function (event) {
            if (event.animationName === 'giro') {
              $cubeWrapper.className += ' error';
            }
          };

          $cube.addEventListener('animationiteration', cycleEnd, false);
        }
      });

      // View:
      return m('div', { class: 'ds-cube-loader-wrapper' }, [
        m('div', { class: 'spinner' }),
        m('div', { class: 'ds-cube-wrapper', config: render.depend('cubeWrapper') }, [
          m('div', { class: 'ds-cube', config: render.depend('cube') }, [
            generateCubeFaces()
          ])
        ])
      ]);
    };

    // Public functions:
    return Loader;

  });
